import useLogoUrlReplacement from 'components/Dashboard/UserContent/ui/useLogoUrlReplacement';
import { hex_is_light } from 'components/Reports/ui/ReportDesignButton';

interface UploadHubLandingPreviewProps {
  organisationLogo: string | null;
  backgroundColour: string;
  barBackgroundColour: string;
  fileName: string;
}

const UploadHubLandingPreview = (props: UploadHubLandingPreviewProps) => {
  const { organisationLogo, backgroundColour, barBackgroundColour, fileName } = props ?? {};
  const { clientLogoReplacement } = useLogoUrlReplacement();
  const logoUrl = organisationLogo?.startsWith('data:')
    ? organisationLogo
    : clientLogoReplacement({ organisationLogo });

  const filenameColor = hex_is_light(barBackgroundColour) ? '#00122b' : ' #fff';

  return (
    <div className='rounded border overflow-hidden' style={{ backgroundColor: backgroundColour }}>
      <div
        className='flex-centered specific-x-padding-14 specific-y-padding-4 justify-content-between border-bottom'
        style={{ backgroundColor: barBackgroundColour }}
      >
        <div style={{ width: '46px', minWidth: '46px' }}>
          {organisationLogo && (
            <img
              src={logoUrl}
              alt='Organisation logo'
              style={{ display: 'block', borderRadius: '2px', height: '11px', objectFit: 'cover' }}
            />
          )}
        </div>
        <span className='flex-grow-1 text-truncate' style={{ color: filenameColor, fontSize: '8px' }}>
          {fileName}
        </span>
      </div>
      <div className='py-3 px-5'>
        <div className='rounded overflow-hidden'>
          <div
            className=' border flex-centered justify-content-center mx-auto'
            style={{
              height: '142px',
              maxWidth: '120px',
              backgroundColor: backgroundColour === '#FFFFFF' ? '#f9f9f9' : '#FFF',
            }}
          >
            <p className='mb-0 main-light-text paragraph-p3'>Your file</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadHubLandingPreview;
